// removed by extract-text-webpack-plugin
module.exports = {"listItem":"marketplaceStats-module_listItem_2WOiP","list":"marketplaceStats-module_list_1tBW_","stats":"marketplaceStats-module_stats_1SkGL"};


//////////////////
// WEBPACK FOOTER
// ./client/components/footer/marketplaceStats.module.css
// module id = 263
// module chunks = 1 2 3